import type { ReactNode } from 'react';
import { brand } from '@/shared/config';
import logoSrc from '@/assets/logo-circular.webp';
import * as s from './HologramHeader.css';

interface HologramHeaderProps {
  systemText: string;
  /** 신원이 확인된 뒤의 이름. 없으면 "플레이어" 로 부른다 */
  playerName?: string;
  /** SYS.GATE 줄 바로 아래 슬롯 (접속 단계 레일) */
  rail?: ReactNode;
}

export const HologramHeader = ({ systemText, playerName, rail }: HologramHeaderProps) => (
  <div className={s.hologramHeader}>
    <div className={s.headerScanLine} />
    <div className={s.headerContent}>
      <div className={s.systemDesignation}>
        <span className={s.designationBracket}>[</span>
        <span className={s.designationCode}>SYS</span>
        <span className={s.designationSeparator}>.</span>
        <span className={s.designationModule}>GATE</span>
        <span className={s.designationVersion}>{brand.coreBanner}</span>
        <span className={s.designationBracket}>]</span>
      </div>
      <div className={s.systemStatus}>
        <span className={s.statusDot} />
        <span className={s.statusText}>ONLINE</span>
      </div>
    </div>
    {rail}
    <div className={s.logoContainer}>
      <img src={logoSrc} alt={brand.logoAlt} className={s.logo} width={72} height={72} />
    </div>
    <div className={s.mainTitle} aria-hidden="true">
      <span className={s.titleGlow}>WELCOME</span>
      <span className={s.titleDivider}>::</span>
      <span className={s.titleText}>{brand.name}</span>
    </div>
    <div className={s.scenarioTag}>
      <span className={s.tagBracket}>[</span>
      <span className={s.tagText}>{systemText}</span>
      <span className={s.tagCursor}>_</span>
      <span className={s.tagBracket}>]</span>
    </div>
    <p className={s.subtitle}>{brand.welcome(playerName)}</p>
  </div>
);
